import { VoucherItem } from "api/Vourcher";
import { useState } from "react";


interface VoucherCardProps {
    voucher: VoucherItem;
}

export default function VoucherCard({ voucher }: VoucherCardProps) {
    const [isSaved, setIsSaved] = useState(false);

    if (!voucher) return null;

    // Helper: Format nhãn hiển thị
    const getLabel = (v: VoucherItem) => {
        if (v.type === 2) {
            return `Giảm ${v.value}%`;
        }
        // Format tiền tệ
        return `Giảm ${new Intl.NumberFormat('vi-VN').format(v.value)}đ`;
    };

    // Helper: Format điều kiện
    const getCondition = (v: VoucherItem) => {
        if (v.min_amount > 0) {
            return `Đơn tối thiểu ${new Intl.NumberFormat('vi-VN').format(v.min_amount)}đ`;
        }
        return "Cho mọi đơn hàng";
    };

    return (
        <div className="flex bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow relative">
            {/* LEFT SIDE: Icon / Image */}
            <div className="w-[100px] bg-blue-50 flex flex-col items-center justify-center border-r border-dashed border-gray-300 p-2 relative shrink-0">
                {/* Răng cưa trang trí */}
                <div className="absolute -left-[6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rounded-full"></div>

                <img
                    src="https://cdn-web-next.thuocsi.vn/icons/productDetail/voucher_icon.svg"
                    alt="voucher"
                    className="w-8 h-8 mb-1"
                />
                <span className="text-[#1D39C4] font-bold text-xs text-center break-all px-1">
                    {voucher.code || "MÃ GIẢM"}
                </span>
            </div>

            {/* RIGHT SIDE: Info */}
            <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
                <div>
                    <h4 className="text-[14px] font-bold text-gray-800 leading-tight mb-1 truncate">
                        {getLabel(voucher)}
                    </h4>
                    <p className="text-[12px] text-gray-500 mb-1 line-clamp-2">
                        {voucher.describe || getCondition(voucher)}
                    </p>
                    <p className="text-[10px] text-gray-400">
                        {voucher.exp_date ? `HSD: ${new Date(voucher.exp_date).toLocaleDateString('vi-VN')}` : 'HSD: Vĩnh viễn'}
                    </p>
                </div>

                <div className="flex justify-end mt-2">
                    <button
                        type="button"
                        onClick={() => setIsSaved(!isSaved)}
                        className={`text-xs px-3 py-1 rounded border transition-colors ${isSaved
                            ? "bg-gray-100 text-gray-400 border-gray-100 cursor-default"
                            : "bg-white text-[#1D39C4] border-[#1D39C4] hover:bg-blue-50"
                            }`}
                        disabled={isSaved}
                    >
                        {isSaved ? "Đã lưu" : "Lưu mã"}
                    </button>
                </div>
            </div>
        </div>
    );
}